<div class="input-search" *ngIf="searchResults?.page?.content?.length">
    <h4 i18n="@@Products">Products</h4>
    <ul class="input-search--products">
        <li *ngFor="let item of searchResults?.page?.content">
            <div class="input-search--products--item" (click)="onClick(item)">
                <div class="input-search--products--item-image">
                    <img [src]="item.image_url" [alt]="item.alt"
                        onError="this.src='assets/images/img-not-available.png';" />
                </div>
                <div style="display: grid;">
                    <div class="input-search--products--item-name">{{item.name}}</div>
                    <!-- <div *ngIf="item.sale_price_percentage" class="input-search--products--item-percentage">-
                        {{item.sale_price_percentage}} %</div> -->
                    <div>
                        <div
                            [ngClass]="item.sale_price_without_tax?.amount ? 'input-search--products--item-sale-price-without-tax' : 'input-search--products--item-price-without-tax'">
                            {{item.priceWithoutTax?.amount | number:
                            "1.0-2"}} {{item.priceWithoutTax?.currency | lowercase}} </div>
                        <div *ngIf="item.sale_price_without_tax?.amount"
                            class="input-search--products--item-price-without-tax">
                            {{item.sale_price_without_tax?.amount
                            | number: "1.0-2" }} {{item.sale_price_without_tax?.currency | lowercase}}</div>
                        <div *ngIf="item.sale_price_percentage"
                            style="color: #e3141a; font-size: 11px; font-weight: 500;">Ušteda: {{
                            item.priceWithoutTax?.amount - item.sale_price_without_tax?.amount | number:
                            "1.0-2"}}
                            {{item?.priceWithoutTax?.currency | lowercase}}</div>
                    </div>
                </div>
            </div>
        </li>
    </ul>
</div>
<ng-container *ngIf="searchResults?.page?.empty || (searchResults?.page?.content?.length === 0)">
    <div class="input-search no-results-container">
        <div class="no-results">
            <div class="no-results-icon">
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                    <circle cx="11" cy="11" r="8"/>
                    <path d="m21 21-4.35-4.35"/>
                    <path d="M16 8a8 8 0 0 0-8 0"/>
                </svg>
            </div>
            <div class="no-results-content">
                <h3 i18n="@@NoSearchResults">Nema rezultata pretrage</h3>
                <p i18n="@@NoProductsMatchSearch">Nismo pronašli proizvode koji odgovaraju vašoj pretrazi</p>
                <div class="no-results-suggestions">
                    <p i18n="@@TryWith">Pokušajte sa:</p>
                    <ul>
                        <li i18n="@@CheckSpelling">Proverom da li ste ukucali reč ispravno</li>
                        <li i18n="@@UseShorterTerms">Korišćenjem kraćih ili opštijih termina</li>
                        <li i18n="@@UseSynonyms">Korišćenjem sinonima ili sličnih reči</li>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</ng-container>